/**
 * Storezone — LoadingSpinner (updated)
 */

import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg'
  label?: string
  className?: string
}

const SIZE_MAP = { xs: 12, sm: 16, md: 24, lg: 40 }

export function LoadingSpinner({
  size = 'md',
  label = 'Loading…',
  className = '',
}: LoadingSpinnerProps) {
  const px = SIZE_MAP[size]
  return (
    <span
      className={`sz-spinner ${className}`}
      role="status"
      aria-label={label}
    >
      <svg
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </span>
  )
}
